import { EditApi } from "./edit/EditApi";
import { ProjectApi } from "./projects/ProjectApi";
import { TripsApi } from "./trips/TripsApi";
/**
 * A collection of all APIs used.
 */
export class Api {
    constructor(accessTokenProvider, settings) {
        this.accessTokenProvider = accessTokenProvider;
        this.edit = new EditApi(settings.editApi);
        this.project = new ProjectApi(settings.projectApi);
        this.trips = new TripsApi(settings.tripsApi);
    }
    /**
     * Gets an access token.
     * @returns The access token.
     */
    async getAccessToken() {
        return await this.accessTokenProvider.getAccessToken();
    }
}
